{
  "MYOPIA_RISK_SCORE_TITLE": "近视风险评分",
  "LITTLE_NO_MYOPIA_RISK_SCORE_PREDICTION_TEMPLATE": "{{PERSONALIZED_NAME}} 可能会保持正视。近视发展的风险很小或没有风险。",
  "LITTLE_MYOPIA_RISK_SCORE_PREDICTION_TEMPLATE": "{{PERSONALIZED_NAME}} 有低风险在16岁之前发展近视。",
  "MODERATE_MYOPIA_RISK_SCORE_PREDICTION_TEMPLATE": "{{PERSONALIZED_NAME}} 有中等风险在13岁之前发展近视。",
  "HIGH_MYOPIA_RISK_SCORE_PREDICTION_TEMPLATE": "{{PERSONALIZED_NAME}} 有高风险在10岁之前发展近视。",
  "NO_NAME_NAME": "您的孩子",
  "MYOPIA_RISK_SCORE_PREDICTION_TITLE": "预测",
  "PREMYOPIA_CATAGORY_LITTLE_TO_NO_RISK": "低/无风险",
  "PREMYOPIA_CATAGORY_LITTLE_RISK": "低风险",
  "PREMYOPIA_CATAGORY_MODERATE_RISK": "中等风险",
  "PREMYOPIA_CATAGORY_HIGH_RISK": "高风险",
  "SCORE_BREAKDOWN": "评分分解",
  "REFRACTIVE": "屈光",
  "AXIAL_LENGTH": "轴长",
  "PARENTAL_MYOPIA": "父母近视",
  "LITTLE_NO_MYOPIA_RISK_SCORE_EIM_TEMPLATE": "{{PERSONALIZED_NAME}} 被识别为近视风险很小或没有风险。\n\n户外活动时间与健康的视觉环境相结合，已被证明可以减少近视发展的风险。{{PERSONALIZED_NAME}} 应该每天在户外活动40分钟，并定期休息近距离视力活动（例如，智能手机、电脑）。",
  "LITTLE_MYOPIA_RISK_SCORE_EIM_TEMPLATE": "{{PERSONALIZED_NAME}} 被识别为有低风险发展近视。\n\n户外活动时间与健康的视觉环境相结合，已被证明可以减少近视发展的风险。{{PERSONALIZED_NAME}} 应该每天在户外活动40分钟，并定期休息近距离视力活动（例如，智能手机、电脑）。",
  "MODERATE_MYOPIA_RISK_SCORE_EIM_TEMPLATE": "{{PERSONALIZED_NAME}} 被识别为有中等风险发展近视。\n\n户外活动时间与健康的视觉环境相结合，已被证明可以减少近视发展的风险。{{PERSONALIZED_NAME}} 应该每天在户外活动40分钟，并定期休息近距离视力活动（例如，智能手机、电脑）。",
  "HIGH_MYOPIA_RISK_SCORE_EIM_TEMPLATE": "{{PERSONALIZED_NAME}} 被识别为有高风险发展近视。\n\n户外活动时间与健康的视觉环境相结合，已被证明可以减少近视发展的风险。{{PERSONALIZED_NAME}} 应该每天在户外活动40分钟，并定期休息近距离视力活动（例如，智能手机、电脑）。",
  "EIM_TITLE": "循证管理",
  "RETEST_PERIOD_6_MONTHS": "建议的重新测试周期为6个月。",
  "RETEST_PERIOD_12_MONTHS": "建议的重新测试周期为1年。",
  "RETEST_PERIOD_24_MONTHS": "建议的重新测试周期为2年。",
  "SER_PERCENTILE_TITLE": "屈光误差",
  "SER_PERCENTILE_DESCRIPTION_TEMPLATE": "{{PERSONALIZED_NAME}} 的屈光误差比同龄人口的 {{PERCENT}}% 更近视。",
  "AXIAL_PERCENTILE_DESCRIPTION_TEMPLATE": "{{PERSONALIZED_NAME}} 的眼睛比同龄和同性别的其他孩子大 {{PERCENT}}%。",
  "WESTERN_DATA_CHOICE": "西方",
  "EAST_ASIAN_DATA_CHOICE": "东亚",
  "AXIAL_X_AXIS": "年龄 [岁]",
  "AXIAL_Y_AXIS": "眼睛大小 [毫米]",
  "CYCLOPLEGIC": "睫状肌麻痹",
  "NON_CYCLOPLEGIC": "非睫状肌麻痹",
  "PERCENTILE": "百分位",
  "RIGHT_EYE": "右眼",
  "LEFT_EYE": "左眼",
  "RIGHT_EYE_MOST_MYOPIC": "右眼 [最近视]",
  "LEFT_EYE_MOST_MYOPIC": "左眼 [最近视]",
  "SER_X_AXIS": "年龄 [岁]",
  "SER_Y_AXIS": "屈光误差 - SER [D]",
  "SINGLE_MYOPE_TITLE": "未来近视进展",
  "AGE_18_MYOPIA_LOW_PREDICTION": "18岁时的低水平近视",
  "AGE_18_MYOPIA_MEDIUM_PREDICTION": "18岁时的中等水平近视",
  "AGE_18_MYOPIA_HIGH_PREDICTION": "18岁时的高水平近视",
  "MYOPIA_SINGLE_VISIT_EVIDENCE_SUGGESTS": "证据表明，如果不进行治疗，Alec在18岁时的屈光结果可能是：",
  "MYOPIA_SINGLE_VISIT_PREDICTION_EXPLAINER": "此估计假设孩子的屈光发育继续保持在今天测量的同一百分位。屈光误差发展的轨迹可能会受到环境、生活方式和近视管理干预的影响。",
  "MYOPIA_SINGLE_VISIT_EIM_TITLE": "循证管理",
  "MYOPIA_SINGLE_VISIT_EIM_RETEST_BRIEF": "重新测试 - {{LENGTH}} {{LENGTH_SUFFIX}}",
  "MYOPIA_PROGRESSION_TITLE": "近视进展",
  "MYOPIA_PROGRESSION_EXPLAINATION_PROJECTED": "此估计是从至少5个月的屈光误差数据中推断出来的。请使用您的临床判断来解释这对您的患者的意义。",
  "MYOPIA_PROGRESSION_EXPLAINATION_MEASURED": "基于至少过去11个月的屈光误差数据。",
  "REFRACTIVE_ERROR_PROGRESSION": "屈光误差进展 [SER]：",
  "AXIAL_LENGTH_PROGRESSION": "轴长进展：",
  "EXTRAPOLATED": "推断",
  "CALCULATED": "计算",
  "MYOPIA_PROGRESSION_EIM_IDENTIFIED": "对于被识别为有高风险近视进展的患者，应讨论和考虑近视管理干预。请根据您的临床判断确定这是否适用于您的患者。",
  "MYOPIA_PROGRESSION_EIM_OPTIONS_TEMPLATE": "目前在英国获准使用的近视管理选项包括：<br><br>1. 近视控制隐形眼镜<br>2. 角膜塑形术<br>3. 近视控制眼镜<br><br>建议的重新测试周期为 {{LENGTH}} {{LENGTH_SUFFIX}}。",
  "MYOPIA_PROGRESSION_EIM_RETEST_TEMPLATE": "重新测试 - {{LENGTH}} {{LENGTH_SUFFIX}}",
  "VIEW_PROGESSION_LITERATURE": "查看进展数据",
  "TEMPLATE_WHAT_IS_MYOPIA": "近视，也称为短视或近视，通常发生在正常眼睛生长过快或持续时间过长时。它会导致远视模糊，可以通过眼镜或隐形眼镜矫正。近视处方以负值或减号（-）表示。随着近视在儿童和青少年时期的发展，这个值通常会增加。",
  "TEMPLATE_WHAT_IS_MYOPIA_MATTER": "近视，也称为短视或近视，通常发生在正常眼睛生长过快或持续时间过长时。它会导致远视模糊，可以通过眼镜或隐形眼镜矫正。近视处方以负值或减号（-）表示。随着近视在儿童和青少年时期的发展，这个值通常会增加。<br><br>近视与晚年视力威胁性眼病的风险增加有关。近视程度越高，风险越大。因此，引入了“近视管理”眼镜和隐形眼镜等干预措施，以减缓眼睛的生长并限制儿童发展近视的程度。如果 {{PERSONALIZED_NAME}} 变得近视，我们可以帮助您选择最适合他的选项。",
  "TEMPLATE_WHY_DOES_EYE_SIZE_MATTER": "虽然您孩子因近视引起的视力模糊可以通过眼镜或隐形眼镜矫正，但近视会增加晚年视力威胁性眼病的风险。近视程度越高和/或眼睛越大，风险越大，因此保持近视水平尽可能低非常重要。",
  "TEMPLATE_HOW_DO_MY_CHILDS_RESULTS_COMPARE_PREMYOPE": "本节中的数据展示了 {{PERSONALIZED_NAME}} 的屈光误差和眼睛大小与同龄其他孩子的对比。在未来的眼科检查中，我们可以使用这些图表来监测他们眼睛变化的速度。如果他们发展近视，这将帮助我们了解他们未来可能会变得多近视。",
  "TEMPLATE_HOW_DO_MY_CHILDS_RESULTS_COMPARE_MYOPIC": "本节中的数据展示了 {{PERSONALIZED_NAME}} 的屈光误差和眼睛大小与同龄其他孩子的对比。就像身高和体重的生长曲线一样，以下折线图中的实线显示了平均眼睛通常随年龄变化的情况，顶部的红色实线表示最近视眼的预期模式。如果您孩子的眼睛生长越过了其中一条“正常”生长线，表示变化速度比预期更快。",
  "TEMPLATE_SLOWDOWN_MYOPIA_PREMYOPE": "我们知道，越早变得近视的孩子最终会有最高水平的近视。孩子是否变得近视取决于他们的基因以及他们的环境和生活方式。您无法改变基因，但为了延迟近视的出现，您可以通过以下方式鼓励 {{PERSONALIZED_NAME}} 采用“健康视觉饮食”：",
  "TEMPLATE_SLOWDOWN_MYOPIA_MYOPIC": "您孩子发展近视的程度部分取决于他们的基因，但也可能受到环境和生活方式的影响。您无法改变基因，但您可以通过以下方式鼓励 {{PERSONALIZED_NAME}} 采用“健康视觉饮食”：",
  "TEMPLATE_SLOWDOWN_MYOPIA_MYOPIC_WITH_TREATMENT": "您孩子发展近视的程度部分取决于他们的基因，但也可能受到环境和生活方式的影响。{{PERSONALIZED_NAME_CAPTIALIZED}} 已经佩戴了设计用于减缓眼睛生长并限制儿童发展近视程度的近视管理眼镜或隐形眼镜。您/您的孩子可以做的一些额外改变如下：",
  "TEMPLATE_WHAT_NEXT_PREMYOPE": "{{PERSONALIZED_NAME}} 有 {{PREMYOPE_RISK}} 变得近视。建议的重新测试周期为 {{LENGTH}} {{LENGTH_SUFFIX}}，但如果您的孩子注意到视力变化，应尽早回来。为开发此报告的统计数据来自6至10岁白人欧洲儿童的数据。如果您的孩子不在此年龄段或种族范围内，预测将不太准确。生长曲线适用于6至18岁的儿童。如果您对本报告有任何疑问，请咨询您的眼科专业人员。",
  "TEMPLATE_WHAT_NEXT_MYOPIC": "在未来的眼科检查中，我们将评估 {{PERSONALIZED_NAME}} 的近视和眼睛大小的变化，以及他们的眼睛生长是否遵循“正常”或“比正常更快”的模式。这将帮助我们为 {{PERSONALIZED_NAME}} 选择最佳的近视管理选项。根据您的眼科医生的指示，定期进行眼科检查对于监测 {{PERSONALIZED_NAME}} 的近视进展以及确保 {{PERSONALIZED_NAME}} 的处方是最新的并且视力是最佳的非常重要。",
  "TEMPLATE_FURTHER_RESOURCES": "全球近视意识联盟 https://www.myopiaawareness.org/uk <br> 验光师学院 '照顾好你的眼睛' https://lookafteryoureyes.org/eye-care/myopia-management-control-eye-care-for-children-who-are-short-sighted/",
  "ENCOURAGE_OUTDOOR_TIMES": "鼓励户外活动时间（每天40分钟，即使是阴天）。",
  "BALANCING_NEAR_ACTIVITIES": "平衡近距离视力活动并鼓励定期休息。",
  "REGULAR_EYE_EXAMS": "定期眼科检查。",
  "MYOPIA_MANAGEMENT_TREATMENT": "设计用于减缓眼睛生长并限制儿童发展近视程度的近视管理眼镜或隐形眼镜。",
  "TITLE_WHAT_IS_MYOPIA": "什么是近视",
  "TITLE_WHAT_IS_MYOPIA_MATTER": "什么是近视及其重要性",
  "TITLE_AMOUNT_MYOPIA_MATTER": "为什么近视程度和眼睛大小很重要",
  "TITLE_HOW_DO_MY_CHILDS_RESULTS_COMPARE": "我孩子的结果与同龄其他孩子相比如何？",
  "TITLE_SLOW_DOWN_MYOPIA": "我的孩子可以做些什么来减缓近视？",
  "TITLE_WHAT_NEXT": "接下来是什么？",
  "TITLE_FURTHER_RESOURCES": "进一步的资源和信息",
  "PREMYOPE_RISK_LITTLE_NONE": "低或无风险",
  "PREMYOPE_RISK_LOW": "低风险",
  "PREMYOPE_RISK_MODERATE": "中等风险",
  "PREMYOPE_RISK_HIGH": "高风险",
  "CREDIT_TITLE": "由阿尔斯特大学和阿斯顿大学为您呈现",
  "CREDIT_TEXT": "本报告是阿尔斯特大学和阿斯顿大学合作的成果，得到了我们的工业合作伙伴[豪雅、依视路璐彩、SightGlass]的资助，他们对近视教育和研究的投入使本报告成为可能。",
  "MYOPIA_RISK_SCORE_DISCLAIMER": "*使用最近一次就诊时最近视的眼睛和阿尔斯特大学的PreMO数据集",
  "BREAKDOWN": "分类",
  "REFRACTIVE_ERROR_PROGRESSION_DASH": "屈光不正进展 [SER]：",
  "AXIAL_PROGRESSION_DASH": "轴长进展：",
  "PROJECTED_WARNING": "使用5-11个月数据计算的年度比率不如使用11个月以上数据的可靠。这些短期估计仅表明趋势，应仅视为初步指标。",
  "AXIAL_PERCENTILE_TITLE": "眼睛大小",
  "MYOPIC_SINGLE_TYPE": "近视",
  "MYOPIC_PROGRESSION_TYPE": "近视进展",
  "PREMYOPIC_TYPE": "前近视",
  "POPULATION_COMPARISON": "人群比较",
  "POPULATION_COMPARISON_DISCLAIMER": "请使用您的临床判断并选择最适合您的诊所和患者人口统计的数据集。",
  "TAKEN_FROM_MOST_MYOPIC_EYE": "取自最近视的眼睛",
  "MYOPIA_SINGLE_VISIT_EIM_TEMPLATE": "{{PERSONALIZED_NAME_CAPITALIZED}}在{{AGE_AT_LATEST_VISIT}}岁时被确定为近视，预计在18岁时将有{{SER_AT_LAST_VISIT}}D的{{LEVEL_OF_MYOPIA}}近视。长期的高度近视与晚年视力威胁性病变的风险增加有关。<br><br>应讨论和考虑近视管理干预。<br><br>目前在英国获准使用的近视管理选项包括：<br>1. 近视控制隐形眼镜<br>2. 夜戴型角膜塑形镜<br>3. 近视控制眼镜<br><br>建议的重新检查周期为{{LENGTH}} {{LENGTH_SUFFIX}}。"
}
